import { styled } from '@mui/material';

import { getBackgroundColorForStatus, getColorForStatus } from '@/shared/lib/statusColors';

export const Container = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
});

export const Status = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'status',
})<{
  status:
    | 'AVAILABLE'
    | 'ACTIVE'
    | 'COMPLETED'
    | 'PARTIALLY_AVAILABLE'
    | 'BOOKED'
    | 'APPROVED'
    | 'CONFIRMED'
    | 'DRAFT'
    | 'PENDING'
    | 'CANCELLED'
    | 'PRINT_PROOF_REQUIRED'
    | 'BLOCKED'
    | 'IN_PROGRESS'
    | 'SHIPPED'
    | 'IN_REVIEW'
    | 'REJECTED'
    | 'DELAYED';
}>(({ theme, status }) => {
  const color = getColorForStatus(status, theme);
  const backgroundColor = getBackgroundColorForStatus(status, theme);

  return {
    backgroundColor,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    cursor: 'pointer',

    '& > p': {
      margin: 0,
      color,
      fontSize: '0.625rem',
      fontWeight: 500,
      textTransform: 'uppercase',
      lineHeight: '130%',
    },
  };
});
